import getCalendarSurfaceStore from '../store/store';
import { DateRange } from 'mini-datetime-utils';
import { OwaDate, getTimestamp } from 'owa-datetime';
import { mutatorAction } from 'satcheljs';
import { ObservableMap } from 'mobx';

/**
 * Update events count map in the calendar surface store
 */

const updateEventsCountMutator = mutatorAction(
    'updateEventsCount',
    (range: DateRange, eventsCountMap: Map<OwaDate, number>) => {
        const eventsCountMapInStore = new ObservableMap<string, number>();
        eventsCountMap.forEach((value: number, key: OwaDate) => {
            // This is done because owaDate getDateString is returning different value than toDateString of new Date()
            // date.toDateString() - "Wed Sep 11 2019"
            // getDateString(owaDate) - 2019-09-11

            const dateString = new Date(getTimestamp(key)).toDateString();
            eventsCountMapInStore.set(dateString, value);
        });
        getCalendarSurfaceStore().eventsCountInfo = {
            range: range,
            eventsCountMap: eventsCountMapInStore,
        };
    }
);

export default updateEventsCountMutator;
